import { Component, OnInit } from '@angular/core';
import * as $ from "jquery";

@Component({
  selector: 'app-samplecenter-sidebar',
  templateUrl: './samplecenter-sidebar.component.html',
  styleUrls: ['./samplecenter-sidebar.component.css']
})
export class SamplecenterSidebarComponent implements OnInit {
  
    userID: any;
  	roleID: any;
  	username: any;
  	isCollectionCenter = false;

  constructor() { }

  ngOnInit() {
    this.username = localStorage.getItem("username");
    this.roleID = localStorage.getItem("role_id");
    this.userID = localStorage.getItem("id");
    if(this.roleID == 5 || this.roleID == 6){
        this.isCollectionCenter =true;
    }
  


		$(document).ready(function(){


			$(".dropDownToggle").click(function(){
			  $(".dropDownToggle-menu").slideToggle(100);
			});

			
			$(".dropDownToggle2").click(function(){
				$(".dropDownToggle2-menu").slideToggle(100);
			  });


		  });
    }
		


    Mobile_sidebar_menu_btn(){
      $(".mobile-menu-asidebar").fadeToggle(500);
    }

		
	}
